import { formatTokenAmount, formatUsd } from '@dapp/multi-lib/lib/formatters';
import { formatUnits } from 'utils/units';

interface VaultPositionDisplayParams {
  position: bigint;
  decimals: number;
  vaultPriceInUsd: number | string;
}

export const getVaultPositionDisplay = (params: VaultPositionDisplayParams) => {
  const { position, decimals, vaultPriceInUsd } = params;
  const tokenAmount = formatTokenAmount(position, decimals, 6);
  const positionUsd =
    parseFloat(formatUnits(position, decimals)) * Number(vaultPriceInUsd);
  const usdAmount = formatUsd(positionUsd);

  if (tokenAmount === '0.000000' && usdAmount === '0.00') {
    return null;
  }

  return { tokenAmount, usdAmount };
};
